import Icon from "@ant-design/icons";
import type { GetProps } from "antd";
type CustomIconComponentProps = GetProps<typeof Icon>;

const ResearchSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 24 24"
  >
    <g
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    >
      <path d="M6.047 9.375a3 3 0 1 0 0-6a3 3 0 0 0 0 6m-.5-8.25h1m-.5 0v2.25m3.359-1.066l.707.707m-.354-.353L8.168 4.254m3.129 1.621v1m0-.5h-2.25m1.066 3.359l-.707.707m.353-.354L8.168 8.496m-1.621 3.129h-1m.5 0v-2.25m-3.359 1.066l-.707-.707m.354.353l1.591-1.591M.797 6.875v-1m0 .5h2.25M1.981 3.016l.707-.707m-.353.354l1.591 1.591M18.146 9.1a6.134 6.134 0 0 1 .315 9.07a6.4 6.4 0 0 1-8.941 0a6.2 6.2 0 0 1-1.558-2.52"></path>
      <path d="M16.151 11.054a.913.913 0 0 1-1.277 0L13.6 9.8a.875.875 0 0 1 0-1.254l3.832-3.764a.915.915 0 0 1 1.277 0l1.277 1.255a.875.875 0 0 1 0 1.254z"></path>
      <path d="m19.168 5.236l2.59-2.592l-1.445-1.445m2.89 2.89l-1.445-1.445M5.797 15.65h5.058m-4.27 7.225h13.728m-6.503-2.89v2.89"></path>
    </g>
  </svg>
);

const ResearchIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={ResearchSvg} {...props} />
);
export default ResearchIcon;
